// extracted by mini-css-extract-plugin
export default {"responsiveGrid":"recipesGrid_responsiveGrid__D61Mp"};